import { useNavigate, useSearch } from '@tanstack/react-router';

import {
  integrationDashboardRouteSearchSchema,
  parseIntegrationDashboardRouteSearch,
  serializeIntegrationDashboardRouteFilters,
} from './integrationDashboardRouteSearch';

export function useIntegrationDashboardRouteFilters() {
  const navigate = useNavigate({
    from: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview',
  });
  const search = useSearch({ strict: false });
  const { range } = parseIntegrationDashboardRouteSearch(
    integrationDashboardRouteSearchSchema(search),
  );

  return {
    range,
    setRange: (nextRange: typeof range) => {
      void navigate({
        search: serializeIntegrationDashboardRouteFilters(nextRange),
        replace: true,
      });
    },
  };
}
